import React, { PropsWithChildren } from 'react';
import styled, { useTheme } from 'styled-components';

import { dateRangeOptions } from 'utils';
import { FilterActions, FormRadioButtons, Title } from 'widgets';
import { Dropdown } from 'widgets/Dropdown';
import { HorizontalLayout, VerticalLayout } from 'widgets/Layout';
import { Text } from 'widgets/Text';

import { DateRangeInput } from '../input/FormDateInput';

interface FormDateRangeOptionsDropdownProps {
    startName: string;
    endName: string;
    title: string;
    onResetEndValue: () => void;
    dropdownTrigger: JSX.Element;
    dateRangeInputTitle?: string;
    onApply: () => void;
    onReset: () => void;
}

/**
 * Note: `startName` key is used by two form inputs, so changes are reflected on both
 * `<FormRadioButtons />` selection is reflected in `<DateRangeInput />` and vice versa
 */
export const FormDateRangeOptionsDropdown = ({
    dropdownTrigger,
    startName,
    endName,
    onResetEndValue,
    title,
    dateRangeInputTitle = 'Custom Date Range',
    onApply,
    onReset,
}: PropsWithChildren<FormDateRangeOptionsDropdownProps>) => {
    const theme = useTheme();

    return (
        <Dropdown overflow="unset" dropdownTrigger={dropdownTrigger}>
            <StyledVerticalLayout $gap={16}>
                <Title content>{title}</Title>
                <DateRangeInput
                    title={dateRangeInputTitle}
                    startName={startName}
                    endName={endName}
                    $iconColor={theme.colors.cocoa500}
                    $outline
                />
                <HorizontalLayout $rowCenter $gap={8}>
                    <Separator />
                    <Text $themeColor="subtle">OR</Text>
                    <Separator />
                </HorizontalLayout>
                <FormRadioButtons
                    title=""
                    name={startName}
                    variant="outline"
                    values={dateRangeOptions}
                    onChange={onResetEndValue}
                />
                <FilterActions onApply={onApply} onReset={onReset} />
            </StyledVerticalLayout>
        </Dropdown>
    );
};

const StyledVerticalLayout = styled(VerticalLayout)`
    padding: 16px;
    width: 360px;
`;

const Separator = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.border.light};
    height: 1px;
`;
